import {Tag} from '@/components-v2/atoms/Tag/Tag'
import {Dropdown} from '@/components-v2/molecules/Dropdown/Dropdown'

/**
 * v2 equivalent of the legacy `@/components/molecules` `DropdownWithTags`: a multi-select
 * `Dropdown` with the selected options rendered as removable `Tag` chips below it.
 * @param {{
 *   childList: Array<{id: string, displayText: string}>,
 *   label?: string,
 *   placeholder?: string,
 *   selection?: 'single' | 'multiple' | 'loading',
 *   selectedOptions?: Array<{id: string, displayText: string}>,
 *   onChange?: (value: Array<{id: string, displayText: string}>) => void,
 *   maxSelections?: number | null,
 *   helperText?: string,
 * }} props
 */
export const DropdownWithTags = ({
  childList = [],
  label = '',
  placeholder = 'Select options',
  selection = 'multiple',
  selectedOptions = [],
  onChange = () => {},
  maxSelections = null,
  helperText = '',
}) => {
  const isOverLimit = maxSelections != null && selectedOptions.length > maxSelections

  const handleSelectedValueChange = value => {
    const limited = maxSelections != null && value.length > maxSelections ? value.slice(0, maxSelections) : value
    onChange(limited)
  }

  const handleRemove = id => {
    onChange(selectedOptions.filter(option => option.id !== id))
  }

  return (
    <div className="flex flex-col gap-2">
      <Dropdown
        label={label}
        childList={childList}
        placeholder={placeholder}
        selection={selection}
        selectedValue={selectedOptions}
        setSelectedValue={handleSelectedValueChange}
        error={isOverLimit}
        helperText={isOverLimit ? `You can only select ${maxSelections} items` : helperText}
      />
      {selectedOptions.length > 0 && (
        <div className="flex flex-row flex-wrap gap-2">
          {selectedOptions.map(option => (
            <Tag key={option.id} text={option.displayText} isRemovable onRemove={() => handleRemove(option.id)} />
          ))}
        </div>
      )}
    </div>
  )
}
